<template>
  <div class="popup">
    <div :class="['content', showRemark ? 'content-with-remark' : '']">
      <div class="top">
        <div>{{goodsItem.goodsName}}</div>
        <div class="iconfont" @click="handleClose">{{'\ue607'}}</div>
      </div>
      <div class="center">
        <div>规格</div>
        <div>{{goodsItem.specification ? goodsItem.specification : '--'}}</div>
      </div>
      <div class="remark" v-if="showRemark">
        <div>备注</div>
        <div>{{goodsItem.remark ? goodsItem.remark : '--'}}</div>
      </div>
      <div class="footer">
        <div class="footer-title">
          <div>单位</div>
          <div>单价/数量</div>
          <div>总价</div>
        </div>
        <div class="footer-content">
          <div>{{goodsItem.unit ? goodsItem.unit : '--'}}</div>
          <div>{{goodsItem.price ? goodsItem.price : '--'}}  /  {{goodsItem.quantity ? goodsItem.quantity : '--'}}</div>
          <div>{{goodsItem.price && goodsItem.quantity ? Number(goodsItem.price) * Number(goodsItem.quantity) : '0.00'}}</div>
        </div>
      </div>
      <div class="add" @click="handleAdd">添加</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    goodsItem: {
      type: Object,
      default: () => {}
    },
    showRemark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    handleAdd () {
      this.$emit('handleAddShop', this.goodsItem)
    }
  }
}
</script>
<style lang="less" scoped>
  .popup{
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 99999;
    .content{
      position: relative;
      border-radius: 4px;
      width: 702px;
      height: 450px;
      top: 50%;
      margin: -225px auto 0px;
      // margin: 50% auto 0px;
      padding: 0px 24px;
      box-sizing: border-box;
      background: #fff;
      &.content-with-remark{
        height: 550px;
        margin-top: -275px;
      }
      .top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1Px solid rgba(236, 238, 241, 0.6);
        div:first-of-type{
          flex-grow: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        div:last-of-type{
          width: 30px;
          // background: red;
        }
        div{
          font-size: 30px;
          font-weight: bold;
          color: #3E4966;
          padding: 28px 0px;
        }
        .iconfont{
          font-size: 18px;
        }
      }
      .center{
        border-bottom: 1Px solid rgba(236, 238, 241, 0.6);
        padding: 20px 0px;
        div:first-of-type{
          font-size: 20px;
          color:#9EA9B9 ;
        }
        div:last-of-type{
          width: 626px;
          font-size: 28px;
          color: #3E4966;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
        }
      }
      .remark{
        border-bottom: 1Px solid rgba(236, 238, 241, 0.6);
        padding: 20px 0px;
        div:first-of-type{
          font-size: 20px;
          color: #9EA9B9;
        }
        div:last-of-type{
          max-height: 108px;
          overflow-y: auto;
          font-size: 28px;
          line-height: 36px;
          color: #3E4966;
          overflow-wrap: anywhere;
          word-break: break-all;
        }
      }
      .footer{
        padding-top: 16px;
        .footer-title{
          font-size: 20px;
          color:#9EA9B9 ;
        }
        .footer-content{
          font-size: 28px;
          color:#3E4966;
        }
        .footer-content>div:first-of-type{
          width: 270px;
        }
        .footer-content>div:nth-of-type(2){
          width: 150px;
          text-align: left;
        }
        .footer-content>div:last-of-type{
          flex-grow: 1;
          text-align: right;
        }
      }
      .footer>div{
        display: flex;
        justify-content: space-between;
      }
      .add{
        width: 100%;
        position: absolute;
        bottom: 0px;
        background:#3378FF;
        font-size: 28px;
        text-align: center;
        height: 96px;
        line-height: 96px;
        left: 0;
        color: #fff;
        font-weight: bold;
      }
    }
  }
</style>
